var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":_vm.btnVariant,"disabled":_vm.isDisabled},on:{"click":_vm.saveAction}},[_vm._v(" "+_vm._s(_vm.btnLabel)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }